import { render, staticRenderFns } from "./DeadAlaByReasonModal.vue?vue&type=template&id=5653159e"
import script from "./DeadAlaByReasonModal.vue?vue&type=script&lang=js"
export * from "./DeadAlaByReasonModal.vue?vue&type=script&lang=js"
import style0 from "./DeadAlaByReasonModal.vue?vue&type=style&index=0&id=5653159e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports